import type { ReactNode } from 'react';

/** **fet** og merket [Fra sjekk] i én linje. Ingen HTML fra modellen. */
function inline(text: string): ReactNode[] {
  return text.split(/(\*\*[^*]+\*\*|\[Fra sjekk\])/g).filter(Boolean).map((part, i) => {
    if (part === '[Fra sjekk]') {
      return (
        <span key={i} className="ml-1 inline-block rounded bg-[#00AF68]/[0.12] px-1.5 align-[1px] text-[10.5px] font-bold uppercase tracking-[0.04em] text-[#007A49]">
          Fra sjekk
        </span>
      );
    }
    if (part.startsWith('**')) return <b key={i}>{part.slice(2, -2)}</b>;
    return part;
  });
}

/**
 * Svaret fra tall-agenten (VIB-2992): avsnitt, lister og fet skrift.
 * Et avsnitt som starter med [Observasjon] vises som observasjon, ikke forslag.
 */
export function AgentAnswer({ text }: { text: string }) {
  const blocks = text.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className="space-y-2">
      {blocks.map((block, i) => {
        const lines = block.split('\n').map((l) => l.trim()).filter(Boolean);
        if (lines.every((l) => /^[-•] /.test(l))) {
          return <ul key={i} className="ml-[18px] list-disc space-y-1">{lines.map((l, j) => <li key={j}>{inline(l.slice(2))}</li>)}</ul>;
        }
        if (lines.every((l) => /^\d+\. /.test(l))) {
          return <ol key={i} className="ml-[18px] list-decimal space-y-1">{lines.map((l, j) => <li key={j}>{inline(l.replace(/^\d+\. /, ''))}</li>)}</ol>;
        }
        if (block.startsWith('[Observasjon]')) {
          return (
            <p key={i} className="rounded-r-lg border-l-[3px] border-[#E0922F] bg-[#E0922F]/[0.08] px-2.5 py-2 text-[13.5px]">
              <b>Observasjon, ikke et forslag:</b> {inline(block.replace('[Observasjon]', '').trim())}
            </p>
          );
        }
        return <p key={i}>{lines.map((l, j) => <span key={j}>{j > 0 && <br />}{inline(l)}</span>)}</p>;
      })}
    </div>
  );
}
